import { render, staticRenderFns } from "./newDashboardTheme.vue?vue&type=template&id=4b267a96"
import script from "./newDashboardTheme.vue?vue&type=script&lang=js"
export * from "./newDashboardTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports